import React from "react";

import {
  IonContent,
  IonToolbar,
  IonHeader,
  IonTitle,
  IonButton,
  IonMenu,
  IonMenuToggle,
  IonItem,
  IonList,
  IonButtons,
} from "@ionic/react";
import { useGame } from "context/gameContext";
import LeagueMessage from "./leagueMessage";
import GeneralMessage from "./generalMessage";
import { useTranslation } from "react-i18next";

const Notifications = () => {
  const {
    state: { messages },
  } = useGame();
  const menuRef = React.useRef(null);
  const { t } = useTranslation();

  const messageList = React.useMemo(() => {
    return messages
      .slice()
      .sort((a, b) => {
        const dateA = a.dateStamp.seconds;
        const dateB = b.dateStamp.seconds;
        return dateB - dateA;
      })
      .map((message, id) => (
        <IonItem key={id}>
          <div className="flex flex-col w-full py-4">
            {message?.type == "invite" ? (
              <LeagueMessage message={message} menuRef={menuRef} />
            ) : message?.type == "public" ? (
              <GeneralMessage message={message} menuRef={menuRef} />
            ) : null}
          </div>
        </IonItem>
      ));
  }, [messages]);

  return (
    <IonMenu
      ref={menuRef}
      contentId="main-content"
      mode="ios"
      side="end"
      type="overlay"
      swipeGesture={false}
    >
      <IonHeader translucent={true} className="ion-no-border !shadow-sm ">
        <IonToolbar mode="ios">
          <IonTitle>{t("messages.header")}</IonTitle>
          <IonButtons slot="end">
            <IonMenuToggle slot="end">
              <IonButton>{t("common.close")}</IonButton>
            </IonMenuToggle>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonList>
          {messageList?.length ? (
            messageList
          ) : (
            <div className="flex items-center justify-center w-full pt-8">
              {t("messages.empty")}
            </div>
          )}
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Notifications;
